module.exports = __webpack_public_path__ + "img/car-B-3.2525e7c9.jpg";